import SimpleDate from 'app/common/classes/simple-date'

export enum FinancesSummaryDetailsGroup {
  Dates = 'dates',
  Students = 'students',
}

export type ReportFinancesSummaryData = ResultFinancesByDatesData | ResultFinancesByStudentsData

export type ItemByDatesType = {
  date: SimpleDate
  balanceBefore: string
  balanceBeforeExists: boolean
  balanceAfter: string | null
  balanceAfterExists: boolean
  payments: string
  paymentsNegative: string
  correctionPayments: string
  correctionPaymentsNegative: string
  writeOffs: string // Списания
  paymentsResult: string // Пополнения
  correctionPaymentsResult: string // Пополнения корректирующие
  check: string | null // Сверка, доступна только для стандартной группировке по датам
}

export type ResultFinancesByDatesData = {
  groupBy: FinancesSummaryDetailsGroup.Dates
  rows: Array<ItemByDatesType>
  title: string
}

export type ItemByStudentsType = {
  studentName: string
  studentKlass: string
  balanceBefore: string
  balanceBeforeExists: boolean
  balanceAfter: string | null
  balanceAfterExists: boolean
  payments: string
  paymentsNegative: string
  correctionPayments: string
  correctionPaymentsNegative: string
  writeOffs: string
  paymentsResult: string
  correctionPaymentsResult: string
}

export type TotalsFinancesByStudentsType = {
  payments: string
  corrections: string
  writeOffs: string
  balanceAfter: string | null
  balanceBefore: string
}

export type ResultFinancesByStudentsData = {
  groupBy: FinancesSummaryDetailsGroup.Students
  rows: Array<ItemByStudentsType>
  title: string
  totals: TotalsFinancesByStudentsType
}
